var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1731.3055,
    height: 300,
    viewBox: "0 0 1731.3055 300",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer3",
    transform: "translate(58.712761,265.38168)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff317c",
      fillOpacity: 1,
      strokeWidth: 1.49588
    },
    id: "rect2",
    width: 780,
    height: 300,
    x: -58.712761,
    y: -265.38168,
    ry: 16.125139
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "292.003px",
      fontFamily: "Helvetica",
      InkscapeFontSpecification: "'Helvetica Bold'",
      fill: "#ff317c",
      fillOpacity: 1,
      strokeWidth: 1.52084
    },
    x: -31.830082,
    y: -11.227139,
    id: "text2"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan2",
    x: -31.830082,
    y: -11.227139,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "292.003px",
      fontFamily: "Helvetica",
      InkscapeFontSpecification: "'Helvetica Bold'",
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      strokeWidth: 1.52084
    }
  }, "Cock")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "254.461px",
      fontFamily: "'Shree Devanagari 714'",
      InkscapeFontSpecification: "'Shree Devanagari 714, '",
      fill: "#ff317c",
      fillOpacity: 1,
      strokeWidth: 1.32531
    },
    x: 764.43506,
    y: -24.33378,
    id: "text3"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan3",
    x: 764.43506,
    y: -24.33378,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "254.461px",
      fontFamily: "'Shree Devanagari 714'",
      InkscapeFontSpecification: "'Shree Devanagari 714, '",
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      strokeWidth: 1.32531
    }
  }, "Roulette"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandNew);
export default __webpack_public_path__ + "static/media/brand_new.5cbac2e938f2c98b9ff124ffb9a32bfd.svg";
export { ForwardRef as ReactComponent };